// 소프트 키보드 등장이나 버튼 조작 등으로 viewport 높이가 변할 때
// vh 기반 레이아웃이 확대/축소되는 현상을 막기 위한 mixin.
//
// 진입 시점의 높이(window.innerHeight) 1%를 --vh 로 고정해 두고,
// SCSS 의 vh() 함수가 이 고정값을 기준으로 레이아웃을 계산하게 한다.
//
// 측정 시점은 "진입 시점"과 "화면 회전 시"뿐이다.
// resize 는 일부러 듣지 않는다 — input 포커스로 소프트 키보드가 올라올 때도
// resize 가 발생하는데, 그때 재측정하면 레이아웃이 다시 출렁이기 때문이다.
export const viewport = {
  methods: {
    setViewportHeight () {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleViewportOrientationChange () {
      // 회전 직후 innerHeight 갱신이 지연되므로 약간의 딜레이 후 재측정
      setTimeout(this.setViewportHeight, 300)
    }
  },
  mounted () {
    this.setViewportHeight()
    window.addEventListener('orientationchange', this.handleViewportOrientationChange)
  },
  beforeDestroy () {
    window.removeEventListener('orientationchange', this.handleViewportOrientationChange)
  }
}
